import { v4 as uuid } from '@lukeed/uuid'
import equal from 'fast-deep-equal'
import { get, writable } from 'svelte/store'

import { browser } from '$app/environment'
import { cleanClient, getClientToPost } from '$lib/cleaners'
import { makeClient } from '$lib/factories'
import { apiPostJson } from '$lib/proxy/apiProxy'
import { debounced, SemaphoreKey } from '$lib/semaphores'
import { account as account_store } from '$lib/stores/account/account'

import { messages } from '../messages'
import type { Client } from '../types/client_types'

export function getUid() {
	if (browser) {
		return uuid()
	}
	return ''
}

export const store = writable(makeClient(getUid))

export async function getClient(client_id: string) {
	console.log('client.ts - getClient - start')

	const jsonData = await apiPostJson('/clients/get', { id: client_id })
	if (jsonData?.error) {
		return
	}
	const clientInfo = jsonData.client

	return clientInfo
}

/**
 *
 * Immediately update the store, and then schedule a save of the client if it changed
 *
 */
export function setClient(updates: Record<string, unknown>) {
	// console.log('setClient:', updates)
	const oldClient = get(store)
	store.update((existing) => ({
		...existing,
		...updates,
		id: updates.id || existing.id || uuid()
	}))
	const newClient = get(store)
	if (equal(cleanClient(oldClient), cleanClient(newClient))) {
		return
	}
	debounced(SemaphoreKey.Client, saveClient)

}

/**
 *
 * Immediately update the store
 * function colled from DesktopEditor 410,
 * just after the call to this function, xxx is called, which saves the data of the invoice and the client.
 */
export function setClientWithoutSave(updates: Record<string, unknown>) {
	// const oldClient = get(store)
	// console.log( 'client.ts - setClientWithoutSave ', oldClient, updates)
	store.update((existing) => ({
		...existing,
		...updates,
		id: updates.id || existing.id || uuid()
	}))
}

export async function forceSaveClient() {
	return await debounced(SemaphoreKey.Client, saveClient, 0)
}

// Saves the (cleaned) client to the server
export async function saveClient() {
	const client = get(store)
	const jsonData = await apiPostJson('/clients/upsert', {
		client: getClientToPost(cleanClient(client))
	})
	if (jsonData?.error) {
		messages.error(`Could not save client: ${jsonData.error.message}`)
	}
}

export function resetClient(client?: Client | null) {
	if (client) {
		//Commented the if to fire all the reactive function pointing to client store
		//if(client.id!==get(store).id){
		// 	console.log('client.ts - resetClient - set **************************************************')
		// 	preloadClient(client)
		//}
		preloadClient(client)
	} else {
		// console.log('client.ts - resetClient - set(makeClient())')
		store.set(makeClient())
	}
}

export function preloadClient(client: Client) {
	store.set(client)
}

export async function chooseClient(client: Client | null = null) {
	if (client === null) {
		resetClient()
	} else {
		store.set(client)
	}
}

export { store as client }
